export default "__VITE_ASSET__Cmce9ITF__"